import { render, staticRenderFns } from "./LyricManager.vue?vue&type=template&id=74e1504e&scoped=true"
import script from "./LyricManager.vue?vue&type=script&lang=js"
export * from "./LyricManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e1504e",
  null
  
)

export default component.exports